import { render, staticRenderFns } from "./Skills-score.vue?vue&type=template&id=d04fbe78&scoped=true&lang=html"
import script from "./Skills-score.vue?vue&type=script&lang=js"
export * from "./Skills-score.vue?vue&type=script&lang=js"
import style0 from "./Skills-score.vue?vue&type=style&index=0&id=d04fbe78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04fbe78",
  null
  
)

export default component.exports